export default __webpack_public_path__ + "static/media/minus.b65631d9.svg";